export default function () {
    this.opts.onClick = {
        close: true,
        preventDefault: false,
        setSelected: true
    };
}
;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/wrappers/angular/mmenu.angular.js
// module id = 109
// module chunks = 0